<template>
    <div id="app">
        <router-view />
        <!-- 显示环境提示 -->
        <!-- <EnvironmentBanner class="environment-banner"/> -->
    </div>
</template>

<script>
import '@/style/global.less';
export default {
    name: 'App'
};
</script>

<style lang="less">
.size {
    width: 100%;
    height: 100%;
}
html,
body {
    .size;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
#app {
    .size;
}
.environment-banner {
    margin-top: 15px;
    margin-right: 220px; /* 设置元素右侧的外边距为20像素 */
}
</style>
